import axios from '../../axios/index.js';

export default {
    /**
     * Triggers Artisan command execution.
     *
     * @param command Artisan command
     *
     * @returns {*}
     */
    executeCommand (command) {
        let formData = new FormData();

        formData.append('command', command);

        return axios.post('/api/v1/admin/execute', formData);
    },
};
